import LessonViewer from '.';
import { LessonProvider } from '../../contexts/LessonContext';

const LessonViewerWrapper = () => (
  <LessonProvider>
    <LessonViewer />
  </LessonProvider>
);

export default LessonViewerWrapper;
